export default {"src":"/_next/static/media/stripe_climate_change_badge.787d444d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};